import { takeLatest } from 'redux-saga/effects';
import * as actionTypesNV04 from '../actions/actionTypesNV04';
import { fetchSnapshotSaga } from './NV04.saga';

export function* watchNV04SnapshotSaga() {
  yield takeLatest(actionTypesNV04.NV04_SNAPSHOT_GET, fetchSnapshotSaga);
}
